import React from 'react';
import { forOwn, get, isUndefined, merge, omit } from 'lodash';
import { validateField } from '../../modelValidator';

export default class ValidatedForm extends React.Component {

  constructor(props) {
    super(props);

    this.validateForm = ::this.validateForm;
  }

  get formModel() {
    const props = merge({}, get(this, 'props'));
    return merge({}, props[props.model], get(props, `tempState[${props.model}]`));
  }

  validateUpdate(model, field, callback) {
    return (event, value) => {
      const state = merge({}, this.state);
      if (!state.validation[field]) {
        state.validation[field] = {};
      }
      state.validation[field].errors = this.validateFormField(field, !isUndefined(value) ? value : get(event, 'target.value'));
      this.setState(state);
      if (callback) {
        callback(model, field, event, value);
      }
    };
  }

  validateFormField(field, value) {
    if (field && this.state.validation && this.state.validation[field]) {
      return validateField(value, omit(this.state.validation[field], 'errors'));
    }
    return [];
  }

  validateForm() {
    const state = merge({}, get(this, 'state'));
    const form = this.formModel;
    let count = 0;
    if (state.validation && form) {
      forOwn(state.validation, (val, key) => {
        state.validation[key].errors = this.validateFormField(key, form[key]);
        count += state.validation[key].errors.length;
      });

      this.setState(state);
    }
    return (count === 0);
  }

}



// WEBPACK FOOTER //
// ./shared/common/components/ValidatedForm.js